import { connect } from 'react-redux';

import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { FOfferType } from '../../utils/category';
import { selectOfferType } from '../../actions/filters';
import { FilterOfferType, IFilterOfferTypeProps } from '../../components/FilterOfferType';
import { togglePopupAutoChangeToSuburban } from '../../reducers/modules/search/building_types';
import { addBusinessTypesToOfferTypes } from '../../utils/addBusinessTypesToOfferTypes';
import { IApplicationContext } from '../../types/application';
import { compose } from 'ramda';
import { withApplicationContext } from '../../utils/applicationContext';

type TFilterOfferTypeDispatchProps = Pick<IFilterOfferTypeProps, 'onSelect' | 'hidePopupAutoChangeToSuburban'>;

export function mapStateToProps(
  state: IApplicationState,
  ownProps: IFilterOfferTypeProps,
): Pick<IFilterOfferTypeProps, 'canShowPopupAutoChangeToSuburban' | 'offerType'> {
  const {
    filters: { jsonQuery },
  } = state;

  const offerType: IFilterOfferTypeProps['offerType'] = addBusinessTypesToOfferTypes(
    jsonQuery.ready_business_types?.value,
    ownProps.offerType,
  );

  return {
    canShowPopupAutoChangeToSuburban: Boolean(state.buildingType.canShowPopupAutoChangeToSuburban),
    offerType,
  };
}

export const mapContextToProps = ({ config }: IApplicationContext) => {
  return { isSearchFlatShareEnabled: config.getStrict('frontend_search_flat_share_enabled.Enabled') };
};

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterOfferTypeDispatchProps {
  return {
    onSelect: (offerType: FOfferType) => dispatch(selectOfferType(offerType)),
    hidePopupAutoChangeToSuburban: () => {
      dispatch(togglePopupAutoChangeToSuburban(false));
    },
  };
}

export const FilterOfferTypeContainer = compose(
  withApplicationContext(mapContextToProps),
  connect(mapStateToProps, mapDispatchToProps),
)(FilterOfferType);
